var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootprintBrands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 256,
    viewBox: "0 0 187 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-13.5613 26.761C-13.5613 35.6288 -6.37648 42.8176 2.48644 42.8176C11.3494 42.8176 18.5342 35.6288 18.5342 26.761C18.5342 17.8932 11.3494 6.28117e-07 2.48644 1.40294e-06C-6.37649 2.17776e-06 -13.5613 17.8932 -13.5613 26.761Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9184 26.761C27.9184 35.6288 35.1033 42.8176 43.9662 42.8176C52.8291 42.8176 60.0139 35.6288 60.0139 26.761C60.0139 17.8932 52.8291 6.28117e-07 43.9662 1.40294e-06C35.1033 2.17776e-06 27.9184 17.8932 27.9184 26.761Z",
    stroke: "#208C72",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3979 26.761C69.3979 35.6288 76.5827 42.8176 85.4457 42.8176C94.3086 42.8176 101.493 35.6288 101.493 26.761C101.493 17.8932 94.3086 6.28117e-07 85.4457 1.40294e-06C76.5827 2.17776e-06 69.3979 17.8932 69.3979 26.761Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110.877 26.761C110.877 35.6288 118.062 42.8176 126.925 42.8176C135.788 42.8176 142.973 35.6288 142.973 26.761C142.973 17.8932 135.788 6.28117e-07 126.925 1.40294e-06C118.062 2.17776e-06 110.877 17.8932 110.877 26.761Z",
    stroke: "#F28520",
    strokeWidth: 4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.357 26.761C152.357 35.6288 159.541 42.8176 168.404 42.8176C177.267 42.8176 184.452 35.6288 184.452 26.761C184.452 17.8932 177.267 6.28117e-07 168.404 1.40294e-06C159.541 2.17776e-06 152.357 17.8932 152.357 26.761Z",
    stroke: "#EA1763",
    strokeWidth: 4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.5613 80.2825C-13.5613 89.1503 -6.37648 96.3391 2.48644 96.3391C11.3494 96.3391 18.5342 89.1503 18.5342 80.2825C18.5342 71.4147 11.3494 53.5215 2.48644 53.5215C-6.37649 53.5215 -13.5613 71.4147 -13.5613 80.2825Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8999 133.805C27.8999 142.673 35.0847 149.862 43.9476 149.862C52.8105 149.862 59.9954 142.673 59.9954 133.805C59.9954 124.937 52.8105 107.044 43.9476 107.044C35.0847 107.044 27.8999 124.937 27.8999 133.805Z",
    stroke: "#208C72",
    strokeWidth: 4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.5613 187.326C-13.5613 196.194 -6.37648 203.383 2.48644 203.383C11.3494 203.383 18.5342 196.194 18.5342 187.326C18.5342 178.459 11.3494 160.565 2.48644 160.565C-6.37649 160.565 -13.5613 178.459 -13.5613 187.326Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.5615 240.849C-13.5615 249.717 -6.37673 256.905 2.4862 256.905C11.3491 256.905 18.5339 249.717 18.5339 240.849C18.5339 231.981 11.3491 214.088 2.48619 214.088C-6.37673 214.088 -13.5615 231.981 -13.5615 240.849Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9184 80.2825C27.9184 89.1503 35.1033 96.3391 43.9662 96.3391C52.8291 96.3391 60.0139 89.1503 60.0139 80.2825C60.0139 71.4147 52.8291 53.5215 43.9662 53.5215C35.1033 53.5215 27.9184 71.4147 27.9184 80.2825Z",
    stroke: "#F28520",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-13.5613 133.805C-13.5613 142.673 -6.37648 149.862 2.48644 149.862C11.3494 149.862 18.5342 142.673 18.5342 133.805C18.5342 124.937 11.3494 107.044 2.48644 107.044C-6.37649 107.044 -13.5613 124.937 -13.5613 133.805Z",
    stroke: "#F28520",
    strokeWidth: 4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9184 187.326C27.9184 196.194 35.1033 203.383 43.9662 203.383C52.8291 203.383 60.0139 196.194 60.0139 187.326C60.0139 178.459 52.8291 160.565 43.9662 160.565C35.1033 160.565 27.9184 178.459 27.9184 187.326Z",
    stroke: "#208C72",
    strokeWidth: 4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9182 240.849C27.9182 249.717 35.103 256.905 43.9659 256.905C52.8289 256.905 60.0137 249.717 60.0137 240.849C60.0137 231.981 52.8289 214.088 43.9659 214.088C35.103 214.088 27.9182 231.981 27.9182 240.849Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3979 80.2825C69.3979 89.1503 76.5827 96.3391 85.4457 96.3391C94.3086 96.3391 101.493 89.1503 101.493 80.2825C101.493 71.4147 94.3086 53.5215 85.4457 53.5215C76.5827 53.5215 69.3979 71.4147 69.3979 80.2825Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3979 133.805C69.3979 142.673 76.5827 149.862 85.4457 149.862C94.3086 149.862 101.493 142.673 101.493 133.805C101.493 124.937 94.3086 107.044 85.4457 107.044C76.5827 107.044 69.3979 124.937 69.3979 133.805Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3979 187.326C69.3979 196.194 76.5827 203.383 85.4457 203.383C94.3086 203.383 101.493 196.194 101.493 187.326C101.493 178.459 94.3086 160.565 85.4457 160.565C76.5827 160.565 69.3979 178.459 69.3979 187.326Z",
    stroke: "#208C72",
    strokeWidth: 4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3977 240.849C69.3977 249.717 76.5825 256.905 85.4454 256.905C94.3083 256.905 101.493 249.717 101.493 240.849C101.493 231.981 94.3083 214.088 85.4454 214.088C76.5825 214.088 69.3977 231.981 69.3977 240.849Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.877 80.2825C110.877 89.1503 118.062 96.3391 126.925 96.3391C135.788 96.3391 142.973 89.1503 142.973 80.2825C142.973 71.4147 135.788 53.5215 126.925 53.5215C118.062 53.5215 110.877 71.4147 110.877 80.2825Z",
    stroke: "#EA1763",
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M110.877 133.805C110.877 142.673 118.062 149.862 126.925 149.862C135.788 149.862 142.973 142.673 142.973 133.805C142.973 124.937 135.788 107.044 126.925 107.044C118.062 107.044 110.877 124.937 110.877 133.805Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M110.877 187.326C110.877 196.194 118.062 203.383 126.925 203.383C135.788 203.383 142.973 196.194 142.973 187.326C142.973 178.459 135.788 160.565 126.925 160.565C118.062 160.565 110.877 178.459 110.877 187.326Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.877 240.849C110.877 249.717 118.062 256.905 126.925 256.905C135.788 256.905 142.973 249.717 142.973 240.849C142.973 231.981 135.788 214.088 126.925 214.088C118.062 214.088 110.877 231.981 110.877 240.849Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M152.357 80.2825C152.357 89.1503 159.541 96.3391 168.404 96.3391C177.267 96.3391 184.452 89.1503 184.452 80.2825C184.452 71.4147 177.267 53.5215 168.404 53.5215C159.541 53.5215 152.357 71.4147 152.357 80.2825Z",
    stroke: "#208C72",
    strokeWidth: 4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M152.357 133.805C152.357 142.673 159.541 149.862 168.404 149.862C177.267 149.862 184.452 142.673 184.452 133.805C184.452 124.937 177.267 107.044 168.404 107.044C159.541 107.044 152.357 124.937 152.357 133.805Z",
    stroke: "#F28520",
    strokeWidth: 4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M152.357 187.326C152.357 196.194 159.541 203.383 168.404 203.383C177.267 203.383 184.452 196.194 184.452 187.326C184.452 178.459 177.267 160.565 168.404 160.565C159.541 160.565 152.357 178.459 152.357 187.326Z",
    stroke: "#F28520",
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M152.357 240.849C152.357 249.717 159.541 256.905 168.404 256.905C177.267 256.905 184.452 249.717 184.452 240.849C184.452 231.981 177.267 214.088 168.404 214.088C159.541 214.088 152.357 231.981 152.357 240.849Z",
    stroke: "#3360AD",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprintBrands);
export default __webpack_public_path__ + "static/media/footprint-brands.b84708a3ac885a12c7571e3a055e9fcd.svg";
export { ForwardRef as ReactComponent };